module.exports = __webpack_public_path__ + "media/images/app/products/index/types/earrings-mobile-3f8482256cc20c4fc5047edc313cffa0.webp";